module.exports = __webpack_public_path__ + "img/rear.aebc5cb6.svg";